import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, Phone, Megaphone } from "lucide-react";
import Marquee from "react-fast-marquee";
import { api } from "../lib/api";
import { useContent } from "../context/ContentContext";
import { ThemeToggle } from "./ThemeToggle";

const links = [
  { to: "/", key: "menu_beranda", def: "Beranda" },
  { to: "/profil", key: "menu_profil", def: "Profil" },
  { to: "/bidang", key: "menu_bidang", def: "Bidang PB" },
  { to: "/informasi", key: "menu_informasi", def: "Info Kebencanaan" },
  { to: "/informasi-publik", key: "menu_informasi_publik", def: "Informasi Publik" },
  { to: "/produk-hukum", key: "menu_produk_hukum", def: "Produk Hukum" },
  { to: "/layanan", key: "menu_layanan", def: "Layanan" },
  { to: "/berita", key: "menu_berita", def: "Berita" },
  { to: "/kegiatan", key: "menu_kegiatan", def: "Kegiatan" },
  { to: "/galeri", key: "menu_galeri", def: "Galeri" },
  { to: "/faq", key: "menu_faq", def: "FAQ" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [tickers, setTickers] = useState([]);
  const { c } = useContent();
  const darurat = c("kontak_darurat", "112");
  useEffect(() => {
    api.get("/tickers").then((r) => setTickers(r.data)).catch(() => {});
  }, []);
  return (
    <header className="sticky top-0 z-50 glass-nav border-b border-slate-200">
      <div className="bg-gradient-to-r from-slate-950 via-slate-900 to-sky-950 text-slate-100 text-xs">
        <div className="max-w-7xl mx-auto px-4 py-1.5 flex items-center gap-4">
          <span className="font-mono shrink-0">Pemerintah Kabupaten Kayong Utara</span>
          {tickers.length > 0 && (
            <div className="flex-1 min-w-0 border-l border-white/15 pl-4" data-testid="topbar-ticker">
              <Marquee speed={38} pauseOnHover gradient={false}>
                {tickers.map((t) => (
                  <span key={t.id} className="inline-flex items-center gap-2 mx-8">
                    <Megaphone size={11} className="text-amber-400 shrink-0" />
                    {t.text}
                  </span>
                ))}
              </Marquee>
            </div>
          )}
          <a href={`tel:${darurat}`} className={`flex items-center gap-1.5 text-orange-400 font-semibold shrink-0 ${tickers.length ? "" : "ml-auto"}`} data-testid="topbar-emergency-phone">
            <Phone size={12} /> Darurat: {darurat}
          </a>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-3" data-testid="navbar-logo">
          <img src="/logo-bpbd.png" alt="Logo BPBD Kayong Utara" className="logo-spin w-11 h-11 object-contain" />
          <div className="leading-tight">
            <p className="font-heading font-bold text-slate-900 text-sm">BPBD</p>
            <p className="text-[11px] text-slate-500">Kabupaten Kayong Utara</p>
          </div>
        </Link>
        <nav className="hidden lg:flex items-center gap-0.5">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.def.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `nav-underline px-2.5 py-2 text-sm font-medium rounded transition-colors ${
                  isActive ? "active text-orange-600" : "text-slate-700 hover:text-orange-600"
                }`
              }
            >
              {c(l.key, l.def)}
            </NavLink>
          ))}
          <ThemeToggle className="ml-2" />
          <Link to="/layanan#lapor" className="btn-pop ml-2 px-5 py-2 bg-orange-600 hover:bg-orange-500 text-white text-sm font-bold rounded-full" data-testid="nav-lapor-btn">
            {c("menu_lapor", "Lapor Bencana")}
          </Link>
        </nav>
        <div className="flex items-center gap-2 lg:hidden">
          <ThemeToggle />
          <button className="p-2" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle">
            {open ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="lg:hidden bg-white border-t border-slate-200 px-4 py-3 space-y-1" data-testid="mobile-menu">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="block px-3 py-2 text-sm font-medium text-slate-700 hover:bg-orange-50 rounded">
              {c(l.key, l.def)}
            </NavLink>
          ))}
          <Link to="/layanan#lapor" onClick={() => setOpen(false)} className="block px-3 py-2 bg-orange-600 text-white text-sm font-semibold rounded text-center">
            {c("menu_lapor", "Lapor Bencana")}
          </Link>
        </nav>
      )}
    </header>
  );
};
